import { Component, Output, EventEmitter, inject } from '@angular/core';
import { AdminService } from '../../admin.service';
import { saveAs } from '@progress/kendo-file-saver';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-download-mapping-files',
  templateUrl: './download-mapping-files.component.html',
  styleUrls: ['../toolbox.component.scss'],
  imports: [MatSelectModule, FormsModule, MatButtonModule],
})
export class DownloadMappingFilesComponent {
  private admnSrvc = inject(AdminService);

  @Output() toggleLoading = new EventEmitter();
  availableSolutions = [{ value: 'dl', label: 'Transaction Monitor' }];
  solutionName = '';
  downloadRecentSLF = {
    id: null,
    app: null,
    status: null,
    statusClass: null,
  };

  getMappingFile() {
    this.toggleLoading.emit();

    this.admnSrvc.getMappingFile(this.solutionName).subscribe({
      next: res => {
        this.toggleLoading.emit();
        let fileData;
        const filename = `${this.solutionName.toUpperCase()}-MappingFile.zip`;
        const reader = new FileReader();
        reader.readAsDataURL(res);

        reader.onloadend = () => {
          fileData = reader.result;
          saveAs(fileData, filename);
        };
      },
      error: err => {
        this.toggleLoading.emit();
        this.downloadRecentSLF.status = err?.error || err || 'Server error';
        this.downloadRecentSLF.statusClass = 'failure';
      },
    });
  }
}
